<template>
  <div class="container-custom">
    <!-- BreadScrumbs -->
    <BreadScrumbs
      :links="[{ name: 'Account List', to: { path: '/account-list' } }]"
    ></BreadScrumbs>
    <!-- page-actions -->
    <div class="page-actions">
      <h2>Account List</h2>
      <v-spacer></v-spacer>
    </div>
    <!--  -->
    <AccountListTable></AccountListTable>
  </div>
</template>

<script>
import BreadScrumbs from '@/components/Breadscrumbs.vue';
import AccountListTable from '@/views/M-1__AccountList/c/AccountListTable.vue';

export default {
  components: {
    BreadScrumbs,
    AccountListTable,
  },
};
</script>

<style></style>
